const en = {
  book_appointment_meeting_step_title: 'Meeting',
  book_appointment_meeting_step_subtile: 'Select a place for your appointment',
  book_appointment_confirm_appointment_button_title: 'Your appointments',
  book_appointment_confirm_calendar_button_title: 'Add to calendar',
  book_appointment_confirm_calendar_failure_title: 'Failed to add',
  book_appointment_confirm_calendar_success_title: 'Already added to calendar',
  book_appointment_confirm_subtitle: 'Your appointment is confirmed for:',
  book_appointment_confirm_title: 'Booking is successful!',
  book_appointment_date_available_slots: 'Available Slots',
  book_appointment_date_cta_button_title: 'Continue',
  book_appointment_date_format: 'EEEE \'%1$s\' \'of\' MMMM',
  book_appointment_timeslot_step_subtile: 'Please choose a suitable time slot',
  book_appointment_timeslot_step_title: 'Date',
  book_appointment_service_step_duration: 'Duration: %1$s',
  book_appointment_service_step_subtile: 'Choose service',
  book_appointment_service_step_title: 'Service',
  book_appointment_store_cta_button_title: 'Continue',
  book_appointment_store_open_time_title: 'Open',
  book_appointment_store_step_title: 'Store',
  book_appointment_summary_cta_button_title: 'Confirm',
  book_appointment_summary_step_assistance: 'assistance',
  book_appointment_summary_step_privacy_hyperlink_text: 'return policy',
  book_appointment_summary_step_subtile: 'Your booking summary',
  book_appointment_summary_step_terms: "By tapping 'Confirm' you accept %1$s and also %2$s.",
  book_appointment_summary_step_terms_hyperlink_text: 'terms and conditions',
  book_appointment_summary_step_title: 'Summary',
  book_appointment_requirements_card_title: 'Requirements',
  book_appointment_view_location: 'View Location',
  book_appointment_timeslots_available: 'Time slots available',
  book_appointment_timeslots_no_available: 'No time slots available',
  book_appointment_add_location: 'Add location',
  book_appointment_continue: 'Continue',
  book_appointment_or: 'or',
  book_appointment_service_step_subtile_admin: 'Choose service',

  date_picker_days_friday: 'F',
  date_picker_days_monday: 'M',
  date_picker_days_saturday: 'S',
  date_picker_days_sunday: 'S',
  date_picker_days_thursday: 'T',
  date_picker_days_tuesday: 'T',
  date_picker_days_wednesday: 'W',
  your_appointments_book_button: 'Book another appointment',
  your_appointments_cancel_booking_button: 'Cancel booking',
  your_appointments_change_booking_button: 'Change booking',
  your_appointments_get_store_directions_button: 'Get store direction',
  your_appointments_header_title: 'Upcoming',
  your_appointments_history_header_title: 'Booking history',
  your_appointments_history_no_appointment_title: 'You do not have any previous appointments',
  your_appointments_history_request_again_button: 'Request again',
  your_appointments_history_review_button: 'Review',
  your_appointments_no_appointment_description: 'Repairs, troubleshooting, information about new products, services or enterprise',
  your_appointments_no_appointment_subtitle: 'You can book an in-store appointment with one of our assistants to help with the following topics:',
  your_appointments_no_appointment_title: 'You do not have any upcoming appointments',
  your_appointments_no_appointment_title_previous: "You do not have any previous appointments",
  your_appointments_screen_title: 'Your appointments',
  your_appointments_service_assistance: 'assistance',
  your_appointments_no_appointment_description_admin: 'Service, solutions, informations about products or new services.',
  your_appointments_no_appointment_subtitle_admin: 'You can reserve an appointments in headquarters or your choosen location with our managers: ',
  your_appointments_no_appointment_button_title: 'Book an appointment',
  your_appointments_current_tab: 'Current appointments',
  your_appointments_past_tab: 'Past appointments',

  book_appointment_extra_data_placeholder: 'Extra data',
  book_appointment_extra_data_input_not_valid: 'Should not be empty',
  book_appointment_street_input_not_valid: 'Should not be empty',
  book_appointment_street_placeholder: 'Street name',
  book_appointment_city_placeholder: 'City',
  book_appointment_add_location_modal_title: 'Add your own address for your appointment',
  book_appointment_add_location_button_title: 'Save address',
  book_appointment_edit_location: 'Edit',
  book_appointment_your_address: 'Meeting address',
  book_appointment_error_title: 'Oops!',
  book_appointment_error_message: 'Something went wrong',
  book_appointment_go_back: 'Go back',
  book_appointment_title: 'Book an appointment',
  book_store_appointment_title: 'Book an in-store appointment',

  book_appointment_service_duration: 'Duration: %1$s %2$s',

  book_appointment_summary_step_policy_modal_title: 'Privacy Policy',
  book_appointment_summary_step_terms_modal_title: 'Terms And Conditions',
  book_appointment_summary_step_policy_modal_url: 'https://api-web-ci-vfal.vodafone.com/file/bookappointment/en.html',
  book_appointment_summary_step_terms_modal_url: 'https://api-web-ci-vfal.vodafone.com/file/bookappointment/en.html'
}

export default en
